import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueRouter from "vue-router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as api from "./utils/api.js";
import "animate.css";
import "./utils/rem.js";
import axios from "axios";
import VueAnimateNumber from "vue-animate-number";
import VueLazyLoad from "vue-lazyload";

Vue.use(VueAnimateNumber);
// src下的assets目录下的图片
Vue.use(VueLazyLoad, {
  error: require("@/assets/R-C.jpg"), // 此处是图片加载失败时候 显示的图片
  loading: require("@/assets/view.png"), // 此处是图片加载中 显示的图片
  attempt: 1, // 加载一屏图片
  preLoad: 1, // 失败尝试次数
});

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.use(ElementUI);
//重写push方法
const originPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location, res, rej) {
  if (res && rej) {
    originPush.call(this, location, res, rej);
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
// 滚动动画 wow.js
import { WOW } from "wowjs";
Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.prototype.$wow = new WOW({
  boxClass: "wow", // default
  // animateClass: "animated", // default
  offset: 300, // default
  mobile: true, // default
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function (box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">");
  },
});
Vue.prototype.$wows = new WOW({
  boxClass: "wows", // default
  // animateClass: "animated", // default
  offset: 300, // default
  mobile: true, // default
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function (box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">");
  },
});
let hasNavigated = false;

router.beforeEach((to, from, next) => {
  if (to.fullPath === from.fullPath && !hasNavigated) {
    // 执行导航操作
    console.log("执行导航操作");
    router.push({ path: "/", query: { id: 7 } });
    hasNavigated = true;
  }

  next();
});
new Vue({
  router,
  store,
  created() {
    // console.log(tos, "ones");
    // this.$router.push({ path: tos, query: { id: 7 } });
  },
  beforeCreate() {
    this.$store.dispatch("fetchData");
  },
  render: (h) => h(App),
}).$mount("#app");
